import CLabel from '@/components/main/CLabel';
import { Degree, Description, DownLoadCV, Globe, PostJob } from '@/components/Svg';
import { useAuthContext } from '@/context/AuthContext';
import { ActionIcon, Button, Card, Grid } from '@mantine/core';
import Image from 'next/image';
import Link from 'next/link';
import { useDispatch } from 'react-redux';

export default function ExpertCard({ expert, dictionary, ...props }) {
  const { user, userDocument } = useAuthContext();
  const dispatch = useDispatch();

  const onDownloadCV = async () => {
    dispatch({
      type: 'cvModal/setCVModalData',
      payload: { data: expert },
    });
    dispatch({ type: 'cvModal/toggleCVModal' });

    // if (user && userDocument.role == "admin") {
    //
    // } else if (user && userDocument.role == "organization") {
    // }
    //	experts/${expert.slug ? expert.slug : expert.id}
  };
  return (
    <>
      <Card
        padding={'lg'}
        withBorder
        style={{ borderRadius: '12px' }}
        className={`${props.className} card-hover`}
      >
        <Grid align="center">
          <Grid.Col span={4}>
            <div className="flex items-center">
              <Link href={`experts/${expert.slug ? expert.slug : expert.id}`}>
                <Image
                  height={50}
                  width={50}
                  
                  className="rounded-full hover:cursor-pointer"
                  radius="xl"
                  src={expert.photoURL ?? '/images/user.svg'}
                  alt={expert.name}
                />
              </Link>
              <div className="ms-4">
                <Link
                  href={`experts/${expert.slug ? expert.slug : expert.id}`}
                  className="no-underline "
                >
                  <h4 className="m-0 text-lg font-semibold transition-all duration-200 cursor-pointer text-grayCustom hover:text-primary">
                    {expert.name}
                  </h4>
                </Link>
                <p className="text-gray-400 text-[14px] my-0">{expert?.position}</p>
              </div>
            </div>
          </Grid.Col>
          <Grid.Col span={4} className="justify-between h-full">
            <div className="flex flex-wrap">
              {expert?.sectors?.map((sector, index) => (
                <CLabel key={index} text={sector} className="mt-1 text-xs me-1" />
              ))}
            </div>
            <div className="flex items-center mt-2 text-primary">
              <Globe width="14" height="19" />
              <p className="text-textGrey ml-2 text-[14px] my-0 whitespace-nowrap">
                {expert?.citizenships.toString()}
              </p>
            </div>
          </Grid.Col>
          <Grid.Col span={3} className="flex flex-col h-full">
            <div className="flex flex-wrap items-center text-primary">
              <PostJob width="18" />
              <p className="text-textGrey ml-2 text-[14px] my-0 whitespace-nowrap">
                {expert?.yearsOfExperience ?? 0} {dictionary.years}
              </p>
            </div>
            <div className="flex flex-wrap items-center mt-2 text-primary">
              <Degree width="18" />
              <p className="text-textGrey ml-2 text-[14px] my-0 whitespace-nowrap">
                {expert.highestDegree}
              </p>
            </div>
          </Grid.Col>

          <Grid.Col span={1} className="flex items-center lg:justify-end ">
            {/* <PDFDownloadLink document={<PdfDocument title="my title" />} fileName="cv-download.pdf">
            {({ blob, url, loading, error }) =>
              loading ? 'Loading document...' : <Button leftIcon={<DownLoadCV />} variant="gradient">
                {dictionary.downloadCV}
              </Button>
            }
          </PDFDownloadLink> */}
            {userDocument?.role == 'organization' || userDocument?.role == 'admin' ? (
              <Button leftIcon={<DownLoadCV />} onClick={onDownloadCV} variant="gradient">
                {dictionary.downloadCV}
              </Button>
            ) : (
              <Link
                href={`/experts/${expert.slug ? expert.slug : expert.id}`}
                className="no-underline "
              >
                <ActionIcon
                  size={'lg'}
                  variant="gradient"
                  aria-label={dictionary.details}
                  title={dictionary.details}
                >
                  <Description />
                </ActionIcon>
              </Link>
            )}
          </Grid.Col>
        </Grid>
      </Card>
    </>
  );
}
